import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isDynamicGroupsFeatureEnabledSelector = (communityId: number) =>
  createSelector(getUserPermissions, (userPermissions) => {
    if (userPermissions?.DYNAMIC_GROUPS?.access)
      return (
        userPermissions.DYNAMIC_GROUPS.access.includes('read') &&
        !!userPermissions.DYNAMIC_GROUPS.communities &&
        !!userPermissions.DYNAMIC_GROUPS.communities[communityId] &&
        !!userPermissions.DYNAMIC_GROUPS.communities[communityId].includes('read')
      );
    else return false;
  });
